module.exports = __webpack_public_path__ + "img/art-19.d8b31b9d.png";